export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--9-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--9-3!../../../node_modules/sass-loader/lib/loader.js??ref--9-4!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./single-customer-dialog.vue?vue&type=style&index=0&id=25619d66&prod&lang=scss"


//////////////////
// WEBPACK FOOTER
// ./src/components/customer/single-customer-dialog.vue?vue&type=style&index=0&id=25619d66&prod&lang=scss
// module id = ftHd
// module chunks = 1